var _rect, _rect2, _path;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var SvgShareToMobile = function SvgShareToMobile(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#F5FAF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#7DBB4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.301 31.6991L32.5096 30.9076L34.8451 28.5593H28.2688V27.441H34.8451L32.5096 25.0926L33.301 24.3012L37 28.0001L33.301 31.6991ZM22.8066 39.1829C22.3061 39.1829 21.8799 39.0069 21.5278 38.6551C21.1759 38.303 21 37.8767 21 37.3763V18.624C21 18.1235 21.1759 17.6973 21.5278 17.3452C21.8799 16.9933 22.3061 16.8174 22.8066 16.8174H32.6127C33.1132 16.8174 33.5394 16.9933 33.8915 17.3452C34.2434 17.6973 34.4193 18.1235 34.4193 18.624V22.3227H33.301V20.7313H22.1183V35.2689H33.301V33.6776H34.4193V37.3763C34.4193 37.8767 34.2434 38.303 33.8915 38.6551C33.5394 39.0069 33.1132 39.1829 32.6127 39.1829H22.8066ZM22.1183 36.3872V37.3763C22.1183 37.5485 22.1899 37.7063 22.3333 37.8496C22.4766 37.9929 22.6344 38.0646 22.8066 38.0646H32.6127C32.7849 38.0646 32.9427 37.9929 33.086 37.8496C33.2294 37.7063 33.301 37.5485 33.301 37.3763V36.3872H22.1183ZM22.1183 19.6131H33.301V18.624C33.301 18.4517 33.2294 18.294 33.086 18.1506C32.9427 18.0073 32.7849 17.9357 32.6127 17.9357H22.8066C22.6344 17.9357 22.4766 18.0073 22.3333 18.1506C22.1899 18.294 22.1183 18.4517 22.1183 18.624V19.6131Z",
    fill: "#448017"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShareToMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share_to_mobile.13904e3b.svg";
export { ForwardRef as ReactComponent };